
import { computed, defineComponent, PropType } from 'vue';
import NP from 'number-precision';
import { ElMessage } from 'element-plus';
import { IDemandSkcPageListItem, IProductionOrderUpdateDetailListItem } from '@/api/production-demand/type';
import { getDemandSkc } from '@/api/production-demand';
import { Delete } from '@element-plus/icons-vue';

export default defineComponent({
  props: {
    tableData: {
      type: Array as PropType<IProductionOrderUpdateDetailListItem[]>,
      default: () => [],
    },
    standardSizeLists: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    suitableColors: {
      type: Array as PropType<IDemandSkcPageListItem[]>,
      default: () => [],
    },
    demandDetailId: {
      type: String,
      default: '',
    },
  },
  emits: ['removeSize', 'removeRow', 'updateSumQuantity'],
  components: { Delete },
  setup(props, { emit }) {
    // 过滤出已确认的颜色
    const suitableColorsList = computed(() => {
      return props.suitableColors?.filter(it => it.confirmed) ?? [];
    });

    // 移除尺码
    const handleRemoveSize = (index: number) => {
      emit('removeSize', index);
    };
    // 移除行
    const handleRemoveRow = (index: number) => {
      emit('removeRow', index);
    };

    // 判断同色、日期是否相同
    const computedColorDate = () => {
      const set = new Set();
      for (let i = 0; i < props.tableData.length; i++) {
        const item = props.tableData[i];
        // 颜色-货期
        if (item.color && item.deliveryDate) {
          const itemKey = `${item.color}-${item.deliveryDate}`;
          if (set.has(itemKey)) return true;
          set.add(itemKey);
        }
      }
      return false;
    };
    // 日期选择，需判断是否相同，（同色下货期不能相同）
    const handleDateChange = (date: string, row: IProductionOrderUpdateDetailListItem) => {
      const hadSameColorDate = computedColorDate();
      console.log('hadSameColorDate: ', hadSameColorDate);
      if (hadSameColorDate) {
        row.deliveryDate = '';
        ElMessage.warning('该颜色货期已存在，请重新选择货期');
      }
    };

    // 修改颜色实时获取确认价
    const onChangeRowColor = async (color: string, row: IProductionOrderUpdateDetailListItem) => {
      const hadSameColorDate = computedColorDate();
      if (hadSameColorDate) {
        row.deliveryDate = '';
        ElMessage.warning('该颜色货期已存在，请重新选择货期');
        return;
      }
      // 每次切换颜色都请求接口获取颜色对应的最新价格
      const { data } = await getDemandSkc({ demandDetailId: props.demandDetailId });
      suitableColorsList.value.forEach((item) => {
        const obj = data.find(it => it.id === item.id);
        item.confirmPrice = obj?.confirmPrice ?? item.confirmPrice;
      });
      // 更新列表显示
      const select = suitableColorsList.value.find(it => it.color === color);
      row.designCode = select?.designCode ?? '';
      row.confirmPrice = select?.confirmPrice ?? '';
    };

    const getTotal = (row: IProductionOrderUpdateDetailListItem) => {
      const sum = row?.sizeQuantityList.reduce((total, cur) => {
        return NP.plus(total, Number(cur.quantity) || 0);
      }, 0);
      row.quantity = String(sum);
      emit('updateSumQuantity');
      return sum;
    };

    const setDisabled = (size: string) => {
      const sizeQuantityList = props.tableData[0]?.sizeQuantityList;
      return sizeQuantityList.some(item => item.size === size);
    };

    return {
      handleDateChange,
      suitableColorsList,
      handleRemoveSize,
      handleRemoveRow,
      onChangeRowColor,
      setDisabled,
      getTotal,
    };
  },
});
